document.addEventListener('DOMContentLoaded', function() {
  
  // ============ SVG FIXES ============
  const svgs = document.querySelectorAll('svg');
  
  svgs.forEach(function(svg) {
    if (svg.getAttribute('aria-label') || 
        svg.getAttribute('aria-labelledby') || 
        svg.querySelector('title')) {
      if (!svg.getAttribute('role')) {
        svg.setAttribute('role', 'img');
      }
      return;
    }
    
    const parent = svg.closest('a, button');
    const hasTextSibling = parent && parent.textContent.trim().length > 0 && 
                           parent.textContent.trim() !== svg.textContent.trim();
    
    const useEl = svg.querySelector('use');
    const iconId = useEl ? (useEl.getAttribute('href') || useEl.getAttribute('xlink:href') || '') : '';
    
    if (hasTextSibling) {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    } else if (iconId) {
      const iconName = iconId.replace(/^#(icon-)?/, '').replace(/-/g, ' ');
      svg.setAttribute('role', 'img');
      svg.setAttribute('aria-label', iconName || 'icon');
    } else if (parent && (parent.tagName === 'A' || parent.tagName === 'BUTTON')) {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    } else {
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    }
  });

  // ============ BUTTON FIXES ============
  const buttons = document.querySelectorAll('button, [role="button"], input[type="button"], input[type="submit"]');
  
  const unclearNames = ['click', 'submit', 'button', 'ok', 'go', 'x', '×', '+', '-', '>', '<', '...', '•'];
  
  const buttonPatterns = {
    'close': 'Close',
    'dismiss': 'Dismiss',
    'modal-close': 'Close dialog',
    'popup-close': 'Close popup',
    'drawer-close': 'Close drawer',
    'menu': 'Open menu',
    'hamburger': 'Open menu',
    'nav-toggle': 'Toggle navigation',
    'mobile-nav': 'Open mobile menu',
    'search-toggle': 'Toggle search',
    'search-open': 'Open search',
    'search-close': 'Close search',
    'cart': 'View cart',
    'add-to-cart': 'Add to cart',
    'add_to_cart': 'Add to cart',
    'remove': 'Remove item',
    'delete': 'Remove item',
    'qty-plus': 'Increase quantity',
    'qty-minus': 'Decrease quantity',
    'quantity-plus': 'Increase quantity',
    'quantity-minus': 'Decrease quantity',
    'plus': 'Increase quantity',
    'minus': 'Decrease quantity',
    'increment': 'Increase quantity',
    'decrement': 'Decrease quantity',
    'prev': 'Previous slide',
    'previous': 'Previous slide',
    'next': 'Next slide',
    'slick-prev': 'Previous slide',
    'slick-next': 'Next slide',
    'flickity-prev': 'Previous slide',
    'flickity-next': 'Next slide',
    'swiper-prev': 'Previous slide',
    'swiper-next': 'Next slide',
    'carousel-prev': 'Previous slide',
    'carousel-next': 'Next slide',
    'slider-prev': 'Previous slide',
    'slider-next': 'Next slide',
    'wishlist': 'Add to wishlist',
    'favorite': 'Add to favorites',
    'compare': 'Add to compare',
    'quickview': 'Quick view',
    'quick-view': 'Quick view',
    'zoom': 'Zoom image',
    'accordion': 'Toggle section',
    'collapse': 'Toggle section',
    'expand': 'Expand section',
    'filter': 'Toggle filters',
    'sort': 'Sort products',
    'share': 'Share',
    'facebook': 'Share on Facebook',
    'twitter': 'Share on Twitter',
    'pinterest': 'Share on Pinterest',
    'email': 'Share via email',
    'copy': 'Copy link'
  };

  buttons.forEach(function(button) {
    let currentName = getAccessibleName(button);
    const nameMissing = !currentName || currentName.trim() === '';
    const nameUnclear = currentName && unclearNames.includes(currentName.toLowerCase().trim());
    
    if (!nameMissing && !nameUnclear) return;
    
    let newName = deriveInteractiveName(button, buttonPatterns, 'button');
    if (newName) {
      button.setAttribute('aria-label', newName);
    }
  });

  // ============ LINK FIXES ============
  const links = document.querySelectorAll('a[href]');
  
  const linkPatterns = {
    // Social media
    'facebook': 'Facebook',
    'twitter': 'Twitter',
    'x.com': 'X (Twitter)',
    'instagram': 'Instagram',
    'pinterest': 'Pinterest',
    'youtube': 'YouTube',
    'tiktok': 'TikTok',
    'linkedin': 'LinkedIn',
    'snapchat': 'Snapchat',
    'vimeo': 'Vimeo',
    
    // Navigation
    'home': 'Home',
    'logo': 'Home',
    'brand': 'Home',
    'menu': 'Menu',
    'nav': 'Navigation',
    
    // Account
    'account': 'My account',
    'login': 'Log in',
    'signin': 'Sign in',
    'sign-in': 'Sign in',
    'logout': 'Log out',
    'signout': 'Sign out',
    'sign-out': 'Sign out',
    'register': 'Create account',
    'signup': 'Sign up',
    'sign-up': 'Sign up',
    
    // Cart/shop
    'cart': 'View cart',
    'basket': 'View basket',
    'bag': 'View bag',
    'checkout': 'Checkout',
    'shop': 'Shop',
    'store': 'Store',
    
    // Search
    'search': 'Search',
    
    // Support
    'contact': 'Contact us',
    'help': 'Help',
    'support': 'Support',
    'faq': 'FAQ',
    
    // Legal
    'privacy': 'Privacy policy',
    'terms': 'Terms of service',
    'cookies': 'Cookie policy',
    
    // Product actions
    'wishlist': 'Wishlist',
    'favorite': 'Favorites',
    'compare': 'Compare',
    'quickview': 'Quick view',
    'quick-view': 'Quick view',
    
    // Arrows/pagination
    'prev': 'Previous',
    'previous': 'Previous',
    'next': 'Next',
    'back': 'Go back',
    
    // Share
    'share': 'Share',
    'email': 'Email',
    'mailto': 'Send email',
    
    // Phone
    'tel:': 'Call us',
    'phone': 'Phone',
    
    // Close
    'close': 'Close',
    
    // External
    'external': 'External link'
  };

  links.forEach(function(link) {
    let currentName = getAccessibleName(link);
    
    // Skip links that already have accessible names
    if (currentName && currentName.trim() !== '') return;
    
    let newName = deriveInteractiveName(link, linkPatterns, 'link');
    
    if (newName) {
      link.setAttribute('aria-label', newName);
    }
  });

  // ============ HELPER FUNCTIONS ============
  
  function getAccessibleName(element) {
    if (element.getAttribute('aria-label')) {
      return element.getAttribute('aria-label');
    }
    
    const labelledBy = element.getAttribute('aria-labelledby');
    if (labelledBy) {
      const labelEl = document.getElementById(labelledBy);
      if (labelEl) return labelEl.textContent;
    }
    
    if (element.value) {
      return element.value;
    }
    
    if (element.getAttribute('title')) {
      return element.getAttribute('title');
    }
    
    // Check for images with alt text
    const img = element.querySelector('img[alt]');
    if (img && img.alt.trim()) {
      return img.alt;
    }
    
    const clone = element.cloneNode(true);
    clone.querySelectorAll('[aria-hidden="true"], .visually-hidden, .sr-only, .screen-reader-text').forEach(el => el.remove());
    return clone.textContent.trim();
  }
  
  function deriveInteractiveName(element, patterns, type) {
    const classes = element.className.toLowerCase();
    const id = (element.id || '').toLowerCase();
    const dataAction = (element.getAttribute('data-action') || '').toLowerCase();
    const ariaControls = (element.getAttribute('aria-controls') || '').toLowerCase();
    const href = (element.getAttribute('href') || '').toLowerCase();
    const title = (element.getAttribute('title') || '').toLowerCase();
    
    const allIdentifiers = `${classes} ${id} ${dataAction} ${ariaControls} ${href} ${title}`;
    
    // Check patterns
    for (const [pattern, label] of Object.entries(patterns)) {
      if (allIdentifiers.includes(pattern)) {
        return label;
      }
    }
    
    // For links, try to extract from href
    if (type === 'link' && href) {
      // Social media URLs
      if (href.includes('facebook.com')) return 'Facebook';
      if (href.includes('twitter.com') || href.includes('x.com')) return 'X (Twitter)';
      if (href.includes('instagram.com')) return 'Instagram';
      if (href.includes('pinterest.com')) return 'Pinterest';
      if (href.includes('youtube.com')) return 'YouTube';
      if (href.includes('tiktok.com')) return 'TikTok';
      if (href.includes('linkedin.com')) return 'LinkedIn';
      if (href.includes('snapchat.com')) return 'Snapchat';
      if (href.includes('vimeo.com')) return 'Vimeo';
      if (href.includes('threads.net')) return 'Threads';
      
      // Phone and email
      if (href.startsWith('tel:')) return 'Call ' + href.replace('tel:', '').replace(/[^\d+]/g, '');
      if (href.startsWith('mailto:')) return 'Email us';
      
      // Skip links
      if (href === '#' || href === '#main' || href === '#content') return 'Skip to content';
      if (href.includes('#main-content')) return 'Skip to main content';
    }
    
    // Check for specific content patterns
    const innerHTML = element.innerHTML.toLowerCase();
    const textContent = element.textContent.trim();
    
    // Symbol-only content
    if (textContent === '×' || textContent === 'x' || textContent === '✕') {
      return 'Close';
    }
    if (textContent === '>' || textContent === '→' || textContent === '›') {
      return 'Next';
    }
    if (textContent === '<' || textContent === '←' || textContent === '‹') {
      return 'Previous';
    }
    if (textContent === '+') {
      return 'Add';
    }
    if (textContent === '-' || textContent === '−') {
      return 'Remove';
    }
    
    // Check for SVG icons
    const svg = element.querySelector('svg');
    if (svg) {
      const useEl = svg.querySelector('use');
      if (useEl) {
        const iconId = (useEl.getAttribute('href') || useEl.getAttribute('xlink:href') || '').toLowerCase();
        for (const [pattern, label] of Object.entries(patterns)) {
          if (iconId.includes(pattern)) {
            return label;
          }
        }
        // Try to derive from icon name
        const iconName = iconId.replace(/^#(icon-)?/, '').replace(/[-_]/g, ' ').trim();
        if (iconName) {
          return iconName.charAt(0).toUpperCase() + iconName.slice(1);
        }
      }
    }
    
    // Check for Font Awesome or similar icon fonts
    const icon = element.querySelector('[class*="fa-"], [class*="icon-"], .icon');
    if (icon) {
      const iconClasses = icon.className;
      const match = iconClasses.match(/(?:fa|icon)[-_](\w+)/);
      if (match) {
        const iconName = match[1].replace(/[-_]/g, ' ');
        return iconName.charAt(0).toUpperCase() + iconName.slice(1);
      }
    }
    
    // Button-specific checks
    if (type === 'button') {
      const parent = element.closest('.quantity, .qty, [class*="quantity"], [class*="qty"]');
      if (parent) {
        if (textContent.includes('+') || allIdentifiers.includes('plus')) {
          return 'Increase quantity';
        }
        if (textContent.includes('-') || textContent.includes('−') || allIdentifiers.includes('minus')) {
          return 'Decrease quantity';
        }
      }
      
      const modal = element.closest('.modal, .popup, .drawer, [class*="modal"], [class*="popup"], [class*="drawer"]');
      if (modal && textContent.length <= 2) {
        return 'Close';
      }
    }
    
    return null;
  }
});